export const requestGasPStyles = (theme) => ({})
